import Column from '@components/Column';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { OptionGroup } from '@models/item';
import { Fragment } from 'react';

import TextOption from '../../../_shared/components/TextOption';

interface Props {
    optionGroups: OptionGroup[];
    itemId: string;
}

function ExpandedPersonalOptions({ optionGroups, itemId }:Props) {
    const { optionCollapsed } = useAppCustom().item;
    if (optionCollapsed) {
        return (<Fragment/>);
    }
    return (
        <Container as='section'
            aria-label='personal-option-container'
            fullWidth >
            {optionGroups.map((optionGroup, idx) => (
                <TextOption optionGroup={optionGroup}
                    optionType='personal'
                    noDivider={idx === 0}
                    key={optionGroup.optionGroupId}
                    itemId={itemId} />
            ))}
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-white);
`;

export default ExpandedPersonalOptions;
